import { Tag } from 'antd';
import styled from 'styled-components';

export default styled(Tag)`
	// Add your styles here
`;
